<script>

import { Overlay } from '../../'

export default {
    name: 'TimeCycle',
    mixins: [Overlay],
    computed: {
        sett() {
            return this.$props.settings
        },
        showCycleHigh() {
            return 'showCycleHigh' in this.sett ?
                this.sett.showCycleHigh : true
        },
        showCycleLow() {
            return 'showCycleLow' in this.sett ?
                this.sett.showCycleLow : true
        },
        showPendingCycleHigh() {
            return 'showPendingCycleHigh' in this.sett ?
                this.sett.showPendingCycleHigh : true
        },
        showPendingCycleLow() {
            return 'showPendingCycleLow' in this.sett ?
                this.sett.showPendingCycleLow : true
        },
    },
    methods: {
        meta_info() {
            return {
                author: 'Mano', version: '1.0.0',
                desc: 'TimeCycle',
                group: 'VT',
                preset: {
                    name: 'TimeCycle',
                    side: 'onchart',
                    settings: {
                        showCycleHigh: true,
                        showCycleLow: true,
                        showPendingCycleHigh: true,
                        showPendingCycleLow: true,
                        lineWidth: 2,
                        zIndex: -3
                    }
                }
            }
        },
        use_for() { return ['TimeCycle'] },
        calc() {
            return {
                props: {
                    showCycleHigh: { def: true, text: 'Cycle High' },
                    showCycleLow: { def: true, text: 'Cycle Low' },
                    showPendingCycleHigh: { def: true, text: 'Pending Cycle High' },
                    showPendingCycleLow: { def: true, text: 'Pending Cycle Low' },
                },
                conf: { renderer: 'TC' }
            }
        }
    }
}
</script>
